import { Easy69_v1 } from "../frfr-easy69-utils";


// -----


// ----- consts
//
export const _zzyourmap_LAYER_TITLE_ALWAYSSHOW = '_alwaysshow';
//
export const _zzyourmap_LAYER_KEY_PREFIX = 'layer_';


// ----- za routing
export const _zzyourmap_lib_tab_keys = ['smestaji', 'restorani', 'servisi', 'prodavnice', 'aktivnosti', 'znamenitosti', 'ostalo', 'blog'];

// -----

//
const _zzyourmap_lib_vr_tablename_values_all = [ // TODO
  'ym_table_smestaj',
  'ym_table_restoran',
  'ym_table_servis',
  'ym_table_prodavnica',
  'ym_table_aktivnost',
  'ym_table_znamenitost',
  'ym_table_ostalo_v2',
  'ym_table_ignored',
  'ym_table_ostalo_v1'
];
//
export const _zzyourmap_lib_vr_tablename_values_entities_with_gallery = [
  'ym_table_smestaj',
  'ym_table_restoran',
  'ym_table_servis',
  'ym_table_prodavnica',
  'ym_table_aktivnost',
  'ym_table_znamenitost',
  'ym_table_ostalo_v2',
  'ym_table_ignored'
  // blog has no gallery
];
//
export const _zzyourmap_lib_vr_tablename_values_ymthing_to_extract = [
  'ym_table_smestaj',
  'ym_table_restoran',
  'ym_table_servis',
  'ym_table_prodavnica',
  'ym_table_aktivnost',
  'ym_table_znamenitost',
  'ym_table_ostalo_v2',
];
//
export const _zzyourmap_lib_vr_tablename_values_ymthing_to_enrich = [
  'ym_table_smestaj',
  'ym_table_restoran',
  'ym_table_servis',
  'ym_table_prodavnica',
  'ym_table_aktivnost',
  'ym_table_znamenitost',
  'ym_table_ostalo_v2',
  'ym_table_ignored' // TODO
];
//
export const _zzyourmap_lib_vr_tablename_values_ymblog = ['ym_table_ostalo_v1'];


//
/*
if (is_tab_default || route_destination_tab === 'smestaji') {
  _naslov_za_list = 'Selekcija smeštaja';
  vr_tablename = 'ym_table_smestaj';
} else if (route_destination_tab === 'restorani') {
  _naslov_za_list = 'Selekcija restorana';
  vr_tablename = 'ym_table_restoran';
} else if (route_destination_tab === 'prodavnice') {
  _naslov_za_list = 'Selekcija prodavnica';
  vr_tablename = 'ym_table_prodavnica';
} else if (route_destination_tab === 'aktivnosti') {
  _naslov_za_list = 'Selekcija aktivnosti';
  vr_tablename = 'ym_table_aktivnost';
} else if (route_destination_tab === 'servisi') {
  _naslov_za_list = 'Selekcija servisa';
  vr_tablename = 'ym_table_servis';
}
*/
export const _zzyourmap_lib_lookup_obj_vr_tablename_to_tab_auto = {
  'ym_table_smestaj': 'smestaji',
  'ym_table_restoran': 'restorani',
  'ym_table_servis': 'servisi',
  'ym_table_prodavnica': 'prodavnice',
  'ym_table_aktivnost': 'aktivnosti',
  'ym_table_znamenitost': 'znamenitosti',
  'ym_table_ostalo_v2': 'ostalo',
  // 'ym_table_ostalo_v1': 'blog',
  // ym_table_ignored
};


// ----- legenda i layeri markera
/*
LEGENDA:
ugostitelji
aktivnosti
smeštaji
prodavnice
servisi
ostalo
(SVA VELIKA SLOVA NA CHECKBOX BUTTONIMA)
*/
export const _zzyourmap_lib_layer_titles_default = [
  "ugostitelji",
  "aktivnosti",
  "smeštaji",
  "prodavnice",
  "servisi",
  "znamenitosti",
  "ostalo",
];
/*
export const _zzyourmap_lib_legend_keys = [ // OLD
  "ugostitelji",
  "aktivnosti",
  "smestaji",
  "prodavnice",
  "servisi",
  "znamenitosti",
  "ostalo",
];
*/
//
/*
export const _zzyourmap_lib_legend_keys_adm = [ // TODO
  ..._zzyourmap_lib_legend_keys,
  "_alwaysshow"
];
*/
////
//
/*
layer_key: "layer_default",
if (item.vr_tablename === 'ym_table_smestaj') {
  marker_single.layer_key = "layer_smestaji";
  marker_single.custom_class = "ym-script__marker__layer_smestaji";
} else if (item.vr_tablename === 'ym_table_aktivnost') {
  marker_single.layer_key = "layer_aktivnosti";
  marker_single.custom_class = "ym-script__marker__layer_aktivnosti";
} else if (item.vr_tablename === 'ym_table_restoran') {
  marker_single.layer_key = "layer_ugostitelji";
  marker_single.custom_class = "ym-script__marker__layer_ugostitelji";
} else if (item.vr_tablename === 'ym_table_prodavnica') {
  marker_single.layer_key = "layer_prodavnice";
  marker_single.custom_class = "ym-script__marker__layer_prodavnice";
} else if (item.vr_tablename === 'ym_table_servis') {
  marker_single.layer_key = "layer_servisi";
  marker_single.custom_class = "ym-script__marker__layer_servisi";
} else if (item.vr_tablename === "ym_table_ostalo_v1") {
  if (item.smestaj_layer && js_utils.is_string_not_empty(item.smestaj_layer) && _zzyourmap_lib_legend_keys.includes(item.smestaj_layer)) {
    marker_single.layer_key = "layer_" + item.smestaj_layer;
    marker_single.custom_class = "ym-script__marker__layer_" + item.smestaj_layer; //
  }
}
*/
export const _zzyourmap_lib_lookup_obj_vr_tablename_to_layer_title_auto = {
  'ym_table_smestaj': 'smeštaji',
  'ym_table_restoran': 'ugostitelji',
  'ym_table_servis': 'servisi',
  'ym_table_prodavnica': 'prodavnice',
  'ym_table_aktivnost': 'aktivnosti',
  'ym_table_znamenitost': 'znamenitosti',
  'ym_table_ostalo_v2': 'ostalo',
  // ym_table_ignored
  // znamenitosti
};
/*
"ugostitelji",
"aktivnosti",
"smestaji",
"prodavnice",
"servisi",
"znamenitosti",
"ostalo",
"_alwaysshow",
*/
//


//
// -----
// EX _zzyourmap_image_library_tags
export const _zzyourmap_lib_image_library_tags_default = ['ikonica', 'mapa', 'galerija', 'glavna', 'smestaj', 'restoran', 'servis', 'prodavnica', 'akivnost', 'ostalo', 'kopaonik', 'dragacevo', 'bajina_basta', 'zlatibor', 'proba'];

